export default __webpack_public_path__ + "static/media/feltest.55e18284.png";